module.exports = __webpack_public_path__ + "static/img/landscape-with-wolves.067b688.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/landscape/landscape-with-wolves.jpg
// module id = CFg9
// module chunks = 0